/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import 'echarts/lib/chart/pie';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/grid';
import 'echarts/lib/component/dataZoom';
import echarts from 'echarts/lib/echarts';
import merge from 'lodash/merge';
import isString from 'lodash/isString';
import { connect } from 'react-redux';
import styles from './styles.scss';


const defaultProps = {
  legend: [],
  title: '',
  height: 0,
};

const defaultTitle = {
  textStyle: {
    fontSize: 16,
    fontWeight: 300,
  },
  textBaseline: 'bottom',
};

const propTypes = {
  height: PropTypes.number,
  series: PropTypes.array.isRequired,
  title: PropTypes.string,
  legend: PropTypes.any,
};

const defaultSeries = {
  label: {
    normal: {
      textStyle: {
        fontWeight: 300,
      },
    },
  },
  radius: [0, '60%'],
};

class PieChart extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      series: props.series,
      legend: props.legend,
    };
    this.tryResizeChart = this.tryResizeChart.bind(this);
  }

  componentDidMount() {
    this.echart = this.initChart();
    this.echart.resize();
    $(window).resize(this.tryResizeChart);
  }

  componentWillReceiveProps(nextProps) {
    const { series, legend } = nextProps;
    if (series !== this.props.series) {
      this.setState({
        series: nextProps.series,
        legend: nextProps.legend,
      });
      this.updateChart(series, legend);
    }
    this.tryResizeChart();
  }

  componentWillUnmount() {
    echarts.dispose($(this.chartRef));
    $(window).off('resize', this.tryResizeChart);
  }

  tryResizeChart() {
    const width = $(this.chartRef).width();
    const height = $(this.chartRef).height();
    if (height !== this.height || width !== this.width) {
      if (this.echart) {
        this.echart.resize();
      }
    }
    this.width = width;
    this.height = height;
  }

  updateChart(nextSeries, nextLegend) {
    const { series: thisSeries } = this.state;
    const series = nextSeries.map(s => ({ ...s, type: 'pie' }));
    const legend = nextLegend || [];
    const option = {
      ...this.echart.getOption(),
      series,
      legend,
    };
    if (!_.isEqual(
          _.map(thisSeries, 'name'),
          _.map(nextSeries, 'name'))) {
      // reset option
      this.echart.clear();
    }
    this.echart.setOption(option);
    this.echart.resize();
  }

  initChart() {
    const echart = echarts.init(this.chartRef);
    const series = this.state.series.map(s => merge(
      defaultSeries,
      {
        ...s,
        type: 'pie',
      },
    ));

    const { legend } = this.props;
    let { title } = this.props;
    if (isString(title)) {
      title = {
        ...defaultTitle,
        text: title,
      };
    }
    const option = {
      title,
      legend,
      series,
      color: PieChart.colors,
    };
    echart.setOption(option);
    return echart;
  }

  render() {
    const { height } = this.props;
    return (
      <div
        style={{ height: height ? `${height}px` : '' }}
        className={styles.chart}
        ref={(ref) => { this.chartRef = ref; }}
      />
    );
  }
}

PieChart.colors = [
  '#22A7F0',
  '#00B16A',
  '#F7CA18',
  '#F9690E',
  '#EF4836',
  '#DB0A5B',
  '#663399',
  '#BF55EC',
  '#446CB3',
  '#336E7B',
  '#1BBC9B',
];
PieChart.propTypes = propTypes;
PieChart.defaultProps = defaultProps;

export default connect(
  state => ({
    collapsed: state.sidebar.collapsed,
  }),
)(PieChart);




// WEBPACK FOOTER //
// ./src/components/PieChart/index.jsx